/**
 * System-only detail
 *
 * A value that only system-level credentials see inside a heading or a line that everyone sees,
 * such as the organisation after a campaign name. The value sits in a detail chip with the badge,
 * so the badge reads as marking the value and not the whole line. Clicks on it never reach a
 * clickable parent, such as a collapsible header.
 */

import React from 'react';
import { DetailChip } from '../DetailChip';
import SystemOnlyBadge from './SystemOnlyBadge';
import Styles from './SystemOnlyBadge.module.css';

interface SystemOnlyDetailProps {
  children: React.ReactNode;
}

export const SystemOnlyDetail: React.FC<SystemOnlyDetailProps> = ({
  children
}) => (
  <DetailChip
    role="presentation"
    className={Styles.detail}
    onClick={(event) => event.stopPropagation()}
  >
    {children}
    <SystemOnlyBadge />
  </DetailChip>
);

export default SystemOnlyDetail;
